import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class SearchForm extends ThemeComponent {
    @Ref() searchInput!: HTMLInputElement;
    @Ref() toggle!: HTMLButtonElement;
    @Ref() toggleClose!: HTMLButtonElement;
    @Ref() container!: HTMLDivElement;

    scrollListener: (() => void)|null = null;

    init() {
        this.$listen(this.toggle, 'click',  () => {
            this.toggleSearch();
            this.toggle.classList.toggle('hidden-above-small-desktop');
        });

        this.$listen(this.toggleClose, 'click',  () => {
            this.toggleSearch();
            this.toggle.classList.remove('visually-hidden');
            this.toggle.classList.remove('hidden-above-small-desktop');
        });
    }

    toggleSearch() {
        document.dispatchEvent(new Event('toggle'));
        document.body.classList.toggle('no-scroll');
        document.querySelector('.site-header')?.classList.toggle('search-active');
        this.container.classList.toggle('is-active');
    }
}
